export var dateTimestampProvider = {
  now: function now() {
    return (dateTimestampProvider.delegate || Date).now();
  },
  delegate: undefined
};